import React from "react";
import { Button, IconButton } from "@material-ui/core";
import ActionIcon from "@material-ui/icons/MoreHoriz";
import ChevronRightRoundedIcon from "@material-ui/icons/ChevronRightRounded";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import { useIsDesktop } from "@my-scoot/exly-react-component-lib";
import ExlyPopover from "common/Components/ExlyPopover";
import { QR_PAYMENT_STATUS } from "ui/pages/payments/DynamicLinkList/components/QrModal.constants";
import { parseBooleanFilter } from "../../utils/qrPayments.utils";
import {
  QR_PAYMENT_STATUS_CODES,
  QR_ACTION_IDS,
  QR_ACTION_LABELS,
} from "../../constants/qrPayments.constants";

export const QrActions = ({ record, onAddCustomer, onSendThankYouLink }) => {
  const isDesktop = useIsDesktop();

  const isConverted = parseBooleanFilter(record?.is_converted);
  const isPaymentSuccess =
    Number(record?.status) === QR_PAYMENT_STATUS_CODES.SUCCESS ||
    record?.status === QR_PAYMENT_STATUS.success;

  // Dev Comment: Hide 3-dot menu if payment status is pending/failed (!isPaymentSuccess)
  // or if payment is already converted (isConverted).
  if (!isPaymentSuccess || isConverted) {
    return null;
  }

  const ActionCta = ({ openPopover }) => {
    return isDesktop ? (
      <IconButton onClick={openPopover} size="small">
        <ActionIcon />
      </IconButton>
    ) : (
      <div
        className="tw-flex tw-items-center tw-gap-1 tw-text-[14px] tw-font-medium tw-text-[#344054] tw-cursor-pointer"
        onClick={openPopover}
      >
        Actions <ChevronRightRoundedIcon />
      </div>
    );
  };

  const PopoverComponent = ({ closePopover }) => {
    const formActions = [
      ...(isPaymentSuccess && !isConverted
        ? [
            {
              id: QR_ACTION_IDS.ADD_CUSTOMER,
              label: QR_ACTION_LABELS.ADD_CUSTOMER_DETAILS,
              icon: PersonAddIcon,
              onClick: onAddCustomer,
            },
          ]
        : []),
      ...(isPaymentSuccess
        ? [
            {
              id: QR_ACTION_IDS.COPY_LINK,
              label: QR_ACTION_LABELS.COPY_DETAIL_LINK,
              icon: FileCopyOutlinedIcon,
              onClick: onSendThankYouLink,
            },
          ]
        : []),
    ];

    return (
      <div>
        {formActions.map(({ id, label, icon: ItemIcon, onClick }) => (
          <div key={id}>
            <Button
              className="!tw-justify-start !tw-normal-case !tw-text-[14px] !tw-font-medium !tw-py-[10px] !tw-px-4 !tw-text-[#344054] !tw-whitespace-nowrap hover:!tw-bg-[#f2f4f7] hover:!tw-text-[#101828]"
              fullWidth
              startIcon={<ItemIcon />}
              onClick={() => {
                if (onClick) {
                  onClick(record);
                }
                closePopover();
              }}
            >
              {label}
            </Button>
          </div>
        ))}
      </div>
    );
  };

  return (
    <ExlyPopover
      AnchorComponent={ActionCta}
      PopoverComponent={PopoverComponent}
      forceDesktopDesign={false}
      popoverProps={{
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "left",
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      }}
    />
  );
};

export default QrActions;
